<template>
  <div>
    <Lock></Lock>
    <Spec v-if="isPageSpec"></Spec>
    <About v-if="isPageAbout"></About>
    <Transition></Transition>
    <ExitAlert></ExitAlert>
    <NotifyRotate></NotifyRotate>
    <Modal></Modal>
    <Loading></Loading>
    <CanvasDebugUI></CanvasDebugUI>
    <div v-show="noModalPage" id="canvasWrapper">
      <TopUI ref="topUI"></TopUI>
      <AreaSelect ref="areaSelect" v-show="isModeArea"></AreaSelect>
      <DrawingHeaderUI></DrawingHeaderUI>
      <PublishUI></PublishUI>
      <DrawEndUI></DrawEndUI>
      <ToolUI ref="toolUI"></ToolUI>
      <!--      <AreaUI></AreaUI>-->
      <TutorialUI></TutorialUI>
      <TextEditUI></TextEditUI>
      <OreCanvas v-show="isShow" ref="oreCanvas"></OreCanvas>
      <PutCursor></PutCursor>
    </div>
    <div id="testImageResize"></div>
  </div>
</template>

<script>
import Transition from "../components/Transition";
import Loading from "../components/ui/Loading";
import Modal from "../components/ui/Modal";
import CanvasDebugUI from "../components/ui/CanvasDebugUI";
import AreaUI from "../components/ui/AreaUI";
import TopUI from "../components/ui/TopUI";
import ToolUI from "../components/ui/ToolUI";
import TutorialUI from "../components/ui/TutorialUI";
import OreCanvas from "../components/Canvas";
import PublishUI from "../components/ui/PublishUI";
import TextEditUI from "../components/ui/TextEditUI";
import DrawEndUI from "../components/ui/DrawEndUI";
import NotifyRotate from "../components/ui/NotifyRotate";
import ExitAlert from "../components/ui/ExitAlert";
import DrawingHeaderUI from "../components/ui/DrawingHeaderUI";
import PutCursor from "../components/draw/PutCursor";
import * as flowEvents from "../events/FlowEvents";
import * as modeTypes from "../store/modules/mode/types";
import API from "../api/API";
import AreaSelect from "../study/AreaSelect";
import * as StoreUtil from "../util/StoreUtil";
import { Preloader } from "../loader/Preloader";
import * as ClockEvent from "../clock/ClockEvent";
import { clock } from "../clock/Clock";
import { noCache } from "../util/Params";
import Storage from "../api/Storage";
import Spec from "./Spec";
import About from "./About";
import Lock from "../components/ui/Lock";

export default {
  name: "CanvasMain",
  components: {
    Lock,
    Spec,
    About,
    Transition,
    Loading,
    Modal,
    AreaSelect,
    CanvasDebugUI,
    AreaUI,
    TopUI,
    ToolUI,
    TutorialUI,
    DrawingHeaderUI,
    PublishUI,
    DrawEndUI,
    ExitAlert,
    NotifyRotate,
    TextEditUI,
    PutCursor,
    OreCanvas
  },
  beforeCreate(){
    const isPC = this.$store.state.device.pc;
    if (isPC) {
      location.href = "pc/?cid=" + this.$store.state.concert.concertId;
    }
    // Androidでコンテキストメニューが出ると消えないので、表示させないようにする
    document.body.addEventListener("contextmenu", ()=> {
      return false;
    })
  },
  async mounted() {
    if (window.devicePixelRatio > 2)
      Konva.pixelRatio = 2;
    if (!navigator.geolocation) {
      alert("このサイトでは位置情報を使用します");
      return;
    }
    Preloader.on("complete", () => {
      console.log("load complete");
      this.init();
    });
    Preloader.start();
    window.evt.on("page", (value)=>{
      StoreUtil.setPage(value)
    })
  },
  computed: {
    isPageSpec() {
      return this.$store.state.common.page == "spec";
    },
    isPageAbout() {
      return this.$store.state.common.page == "about";
    },
    noModalPage() {
      return !this.$store.state.common.page;
    },
    isModeArea() {
      return StoreUtil.isModeArea();
    },
    isModeTransTutorial() {
      return StoreUtil.isModeTransTutorial();
    },
    isShow() {
      return (
        StoreUtil.isModeTutorial() ||
        StoreUtil.isModeDraw() ||
        StoreUtil.isModePublish() ||
        StoreUtil.isModeEnd()
      );
    }
  },
  watch: {
    isModeArea(val) {
      if (val) {
        this.$refs.areaSelect.show();
      }
    },
    isModeTransTutorial(val) {
      if (val) {
        this.$refs.areaSelect.hide();
      }
    }
  },
  methods: {
    async init() {
      console.log("[CanvasMain] init canvas-------");
      await this.login();
      await this.getConcertInfo();
      if (!this.$store.getters["concert/hasClosed"]) {
        clock.on(ClockEvent.PASSED_DEADLINE, () => {
          alert("投稿が締め切られました");
          location.reload();
        });
      }
      await Preloader.loadBgImg("/img/ui/kinsi.png");
      await Preloader.loadBgImg(this.$store.getters["concert/largeBg"]);
      await Preloader.loadBlobImg(this.$store.getters["concert/restrictImg"]);

      console.log("全部loadおわり");
      this.$nextTick(() => {
        this.initTop();
        this.initCanvas();
        StoreUtil.hideLoading();
        this.initGoto();

        // setTimeout(() => {
        //   // TweenMax.globalTimeScale(50);
        //   // StoreUtil.gotoArea();
        //   // StoreUtil.gotoTutorial();
        //   StoreUtil.gotoDraw();
        //   // StoreUtil.setToolText();
        //
        // }, 100);
      });

      // flowEvents.FlowEvents.on(flowEvents.END_AREA, this.onEndArea);
    },
    async login() {
      const userId = this.$store.state.common.userId;
      const concertId = this.$store.state.concert.concertId;
      console.log("Storage.isTabletTokenFlag()", Storage.isTabletTokenFlag());
      console.log("noCache", noCache);
      if (Storage.isTabletTokenFlag()) {
        Storage.removeUserId(concertId);
      }
      else if (!noCache && userId) {
        console.log("has userId");
        return userId;
      }
      if (concertId) {
        const result = await API.login(concertId);
        if (result) {
          this.token = result;
          Preloader.loadBgImg("/img/transition2.png");
        }
        else {
          this.goto404();
        }
      } else {
        // alert("concertIdないです");
        this.goto404();
      }
    },
    goto404() {
      location.href = "/404/";
    },
    async getConcertInfo() {
      const concertId = this.$store.state.concert.concertId;
      return await API.getConcertInfo(concertId);
    },
    initCanvas() {
      this.$refs.oreCanvas.initCanvas();
    },
    initTop() {
      this.$refs.topUI.init();
    },
    initGoto() {
      this.$refs.topUI.initGoto();
    },
    onEndArea() {
      this.$store.dispatch(
        modeTypes.namespace + modeTypes.SET_MODE,
        modeTypes.MODE_TUTORIAL
      );
    }
  }
};
</script>
<style scoped lang="sass">
#canvasWrapper
  position: relative
  //width: 375px
</style>
